import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useSettings, useSeo } from "@/context/SettingsContext";
import { PageHero, FinalCta } from "@/components/site/Blocks";
import { money } from "@/lib/api";

export const faqItems = (s) => [
  ["How much does the trial cost?", `The home trial fee is ${money(s.trial_fee)}. It is only collected after our team confirms your trial, through a clearly disclosed payment process. Submitting the booking form does not charge you.`],
  ["Is my booking confirmed when I submit the form?", "No. Submitting the form is a request. Our team will contact you to confirm eligibility, mower availability, and delivery or pickup arrangements before anything is scheduled."],
  ["How long is the trial?", `The standard trial period is ${s.trial_days} day${s.trial_days > 1 ? "s" : ""}, unless a different period is agreed and confirmed in writing when your trial is booked.`],
  ["Do you deliver the mower?", "Delivery or pickup is arranged according to service availability in your area. Any delivery fee or pickup requirement will be disclosed before your trial is confirmed."],
  ["What happens if I want to buy it?", "Let us know before your trial ends. We'll confirm the purchase price shown for the model and arrange a secure payment. You keep the mower."],
  ["What if I decide not to buy?", "Tell us before the end of your trial period and we'll schedule a collection according to our Trial and Return Policy. Please keep the mower clean and secure until it's collected."],
  ["Which areas do you serve?", s.service_areas?.length ? `We currently serve: ${s.service_areas.join(", ")}. Availability within each area may vary.` : "Service areas are confirmed when we review your request."],
  ["What if the mower gets damaged during the trial?", "Normal use is expected. Damage beyond normal wear is handled as described in the Trial and Return Policy, and condition is recorded at delivery and collection."],
  ["Do I need to be home for delivery and collection?", "We'll agree a delivery and collection window with you. Someone 18+ should be available to receive and hand over the mower."],
  ["How do you use my information?", "We use your details only to manage your trial request and, if you opt in, to send occasional offers. See our Privacy Policy. You can request deletion of your data at any time."],
];

export function FaqList({ items, limit }) {
  return (
    <Accordion type="single" collapsible className="divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white">
      {items.slice(0, limit || items.length).map(([q, a], i) => (
        <AccordionItem key={q} value={`q${i}`} className="border-0 px-6">
          <AccordionTrigger data-testid={`faq-question-${i}`} className="py-5 text-left font-display text-base font-semibold text-slate-900 hover:no-underline">{q}</AccordionTrigger>
          <AccordionContent className="pb-5 text-[15px] leading-relaxed text-slate-600">{a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

export default function Faq() {
  const { settings } = useSettings();
  useSeo("Frequently Asked Questions", "Answers about the $1 home lawn mower trial, delivery, returns and purchasing.");
  return (
    <>
      <PageHero eyebrow="FAQ" title="Questions, answered plainly." text="Everything you need to know about trying a mower at home — no fine print surprises." />
      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-24">
        <FaqList items={faqItems(settings)} />
      </section>
      <FinalCta />
    </>
  );
}
